import http from "../http/http-config";
import { Activities } from "../models/Activities";

export default new class activitiesService {
    getactivities(productId): Promise<Activities[]> {
        return http.get<Activities[]>("GetActivities/", {
            params: {
                ProductId: productId
            }
        }).then(response => response.data)
    }
    
}

